<template>
    <div
      class="resizable-aside"
      :style="{ width: currentWidth + 'px' }"
    >
      <!-- 插槽内容区域 -->
      <div class="aside-content">
        <slot></slot>
      </div>
  
      <!-- 拖拽条 -->
      <div class="resizer" @mousedown="startDrag"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResizableAside',
    props: {
      width: {
        type: Number,
        default: 240,
      },
      minWidth: {
        type: Number,
        default: 240,
      },
      maxWidth: {
        type: Number,
        default: 600,
      },
    },
    data() {
      return {
        currentWidth: this.width,
        isDragging: false,
        startX: 0,
        startWidth: 0,
      }
    },
    methods: {
      startDrag(e) {
        this.isDragging = true
        this.startX = e.clientX
        this.startWidth = this.currentWidth
  
        document.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('mouseup', this.stopDrag)
      },
      handleMouseMove(e) {
        if (!this.isDragging) return
        const deltaX = e.clientX - this.startX
        const newWidth = this.startWidth + deltaX
        this.currentWidth = Math.min(Math.max(newWidth, this.minWidth), this.maxWidth)
        this.$emit('resize', this.currentWidth) // 可选：向父组件传递宽度变化
      },
      stopDrag() {
        this.isDragging = false
        document.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('mouseup', this.stopDrag)
      },
    },
    beforeDestroy() {
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.stopDrag)
    },
  }
  </script>
  
  <style scoped>
  .resizable-aside {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .resizer {
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 100%;
    cursor: ew-resize;
    background-color: transparent;
    z-index: 10;
  }
  
  .resizer:hover {
    background-color: #ccc;
  }
  </style>
  